import { render, staticRenderFns } from "./ProvidedDataForm.vue?vue&type=template&id=99a6801a&"
import script from "./ProvidedDataForm.vue?vue&type=script&lang=js&"
export * from "./ProvidedDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports